import { useState } from "react";
import {
  Container,
  TagCloseButton,
  ValueHighlight,
} from "./FilterControls.styles";
import { DeleteButton, SecondaryButton } from "src/components/Buttons";
import FindSelector from "./FindSelector";
import FindTag from "./FindTag";
import FilterSelector from "./FilterSelector";
import TextInput from "./TextInput";
import {
  CloseIcon,
  Calendar03Icon,
  EraserIcon,
  LabelIcon,
  UserAccountIcon,
} from "src/assets/icons";
import { useTableFilterContext } from "src/context";

export default () => {
  const {
    table,
    textSearchValue,
    selectedStatuses,
    lastUpdated,
    applicationDate,
    role,
    setTextSearchField,
    setTextSearchValue,
    setSelectedStatuses,
    setLastUpdated,
    setApplicationDate,
    setRole,
  } = useTableFilterContext();
  const [findSelection, setFindSelection] = useState<string | null>(null);

  const onDeleteAllFindAndFilter = () => {
    setTextSearchField(null);
    setTextSearchValue(null);
    setSelectedStatuses?.([]);
    setLastUpdated?.({ start: null, end: null });
    setApplicationDate?.({ start: null, end: null });
    setRole?.(null);
  };
  const isAnyFindOrFilterSet =
    textSearchValue ||
    (selectedStatuses && selectedStatuses.length > 0) ||
    (lastUpdated && lastUpdated.start) ||
    (lastUpdated && lastUpdated.end) ||
    (applicationDate && applicationDate.start) ||
    (applicationDate && applicationDate.end) ||
    role;

  return (
    <Container>
      <FindSelector setFindSelection={setFindSelection} />
      <FilterSelector />
      <FindTag />
      {table === "applications" && (
        <>
          {selectedStatuses.length > 0 && (
            <SecondaryButton>
              <LabelIcon />
              Status:{" "}
              <ValueHighlight>
                {selectedStatuses.length === 1
                  ? selectedStatuses[0]
                  : `${selectedStatuses.length} selected`}
              </ValueHighlight>
              <TagCloseButton
                type="button"
                onClick={() => setSelectedStatuses([])}
              >
                <CloseIcon />
              </TagCloseButton>
            </SecondaryButton>
          )}
          {lastUpdated.period && (
            <SecondaryButton>
              <Calendar03Icon />
              Last updated:{" "}
              <ValueHighlight>{lastUpdated.period}</ValueHighlight>
              <TagCloseButton
                type="button"
                onClick={() => setLastUpdated({ start: null, end: null })}
              >
                <CloseIcon />
              </TagCloseButton>
            </SecondaryButton>
          )}
          {applicationDate.period && (
            <SecondaryButton>
              <Calendar03Icon />
              Application date:{" "}
              <ValueHighlight>{applicationDate.period}</ValueHighlight>
              <TagCloseButton
                type="button"
                onClick={() => setApplicationDate({ start: null, end: null })}
              >
                <CloseIcon />
              </TagCloseButton>
            </SecondaryButton>
          )}
        </>
      )}
      {table === "employees" && role && (
        <SecondaryButton>
          <UserAccountIcon />
          Permissions:{" "}
          <ValueHighlight>
            {role.replace("_", " ").toLowerCase()}
          </ValueHighlight>
          <TagCloseButton type="button" onClick={() => setRole(null)}>
            <CloseIcon />
          </TagCloseButton>
        </SecondaryButton>
      )}
      <TextInput
        findSelection={findSelection ?? ""}
        onClose={() => {
          setFindSelection(null);
        }}
      />
      {isAnyFindOrFilterSet && (
        <DeleteButton onClick={onDeleteAllFindAndFilter}>
          <EraserIcon />
          Remove filters
        </DeleteButton>
      )}
    </Container>
  );
};
